<script>
import wootConstants from 'dashboard/constants/globals';
import OptionsMenu from '../userActions/OptionsMenu.vue';
import AgentDetails from '../userActions/AgentDetails.vue';
import NotificationBell from '../userActions/NotificationBell.vue';
import WebphoneMinimized from './WebphoneMinimized.vue';

export default {
  components: {
    OptionsMenu,
    AgentDetails,
    NotificationBell,
    WebphoneMinimized,
  },
  props: {
    isCollapsed: {
      type: Boolean,
      default: false,
    },
    showOptionsMenu: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      helpDocsURL: wootConstants.DOCS_URL,
    };
  },
  methods: {
    toggleOptions() {
      this.$emit('toggle-options');
    },
    openTraining() {
      window.open(
        'https://chat.flipdesk.com.br/hc/treinamento-flipdesk/',
        '_blank'
      );
    },
  },
};
</script>

<template>
  <div
    class="flex items-center shrink-0 border-t border-primary-900/40"
    :class="isCollapsed ? 'flex-col gap-4 py-4' : 'gap-1 sm:gap-2 p-4'"
  >
    <WebphoneMinimized />
    <AgentDetails @toggleMenu="toggleOptions" />
    <NotificationBell
      :is-sidebar-collapsed="isCollapsed"
      @openNotificationPanel="$emit('openNotificationPanel')"
    />
    <woot-button
      v-tooltip="{
        content: $t('SIDEBAR.DOCS'),
        placement: 'right',
        boundariesElement: 'viewport',
        container: 'body',
      }"
      variant="clear"
      color-scheme="white"
      @click="openTraining"
    >
      <div>
        <fluent-icon icon="book-open-globe" />
      </div>
    </woot-button>
    <OptionsMenu
      :show="showOptionsMenu"
      @toggleAccounts="$emit('toggleAccounts')"
      @showSupportChatWindow="$emit('showSupportChatWindow')"
      @openKeyShortcutModal="$emit('openKeyShortcutModal')"
      @close="toggleOptions"
    />
  </div>
</template>
